var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"css-tr"},[_c('div',{staticClass:"css-th"}),_c('div',{staticClass:"css-td"},[_c('p',{staticClass:"notice fn-sm"},[_vm._v("* 電子發票-公司(紙本)將於鑑賞期過後寄出")])])])
}]

export { render, staticRenderFns }